<template>
  <div class="gird">
    <div class="top-title"><span></span>基础信息</div>
    <div class="i-content">
      <base-form
        v-model="baseData"
        :options="baseDataOptions"
        ref="baseData"
        @input="handleChangeBaseData"
        label-width="105px"
      ></base-form>
    </div>
    <div class="i-button">
      <vxe-button size="medium" type="primary" class="vxe-btn-save" @click="save()">
        <svg-icon
          class="icon-img"
          style="font-size: 16px; padding-right: 6px"
          icon-class="icon-preserve"
        />
        {{ $t('credit.btnList.save') }}
      </vxe-button>
    </div>
  </div>
</template>

<script>
  import baseForm from '@/components/form/base-form';
  import { mapState } from 'vuex';
  import COMPANY_API from '@/api/masterData/company.js';
  export default {
    name: 'approvalConfigAdd',
    components: {
      baseForm,
    },
    data() {
      return {
        baseData: {
          billType: null,
          operateType: null,
          dimension: null,
          approval: null,
          role: null,
          priority: null,
          enable: null,
          validDate: null,
          invalidDate: null,
          approverId: null,
          roleCode: null,
          approvalName: null,
          companyCode: null,
          departmentCode: null,
        },
        operateTypeList: [],
        billTypeList: [],
        companyList: [],
        departmentList: [],
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      baseDataOptions() {
        return [
          {
            type: 'select',
            label: '单据类型',
            prop: 'billType',
            options: this.billTypeList,
            required: true,
          },
          {
            type: 'select',
            label: '操作类型',
            prop: 'operateType',
            options: this.operateTypeList,
            required: true,
            disabled: this.baseData?.billType ? false : true,
          },
          {
            label: '维度',
            prop: 'dimension',
            type: 'dict',
            dictType: 'approval_dimension',
            required: true,
          },
          {
            type: 'select',
            label: '公司',
            prop: 'companyCode',
            options: this.companyList,
            placeholder: '请选择公司',
            // disabled: false,
          },
          {
            label: '业务部门',
            type: 'select',
            prop: 'departmentCode',
            options: this.departmentList,
            placeholder: '请选择部门',
            // disabled:
            //   this.baseData.dimension == 'company' ||
            //   this.baseData.dimension === 'role' ||
            //   !this.baseData.dimension
            //     ? true
            //     : false,
          },
          {
            type: 'searchTable',
            label: '审批人',
            prop: 'approval',
            searchType: 'personAccountApprover',
            currentValue: this.baseData.approverName,
            checkRowKeys: [this.baseData.approverId],
            isMultiple: true,
            required: ['approval'].indexOf(this.baseData.dimension) > -1 ? true : false,
            disabled: ['approval'].indexOf(this.baseData.dimension) > -1 ? false : true,
            extraData: {
              companyCode: this.baseData.companyCode || '',
              departmentCode: this.baseData.departmentCode || '',
            },
          },
          {
            type: 'searchTable',
            label: '角色',
            prop: 'role',
            searchType: 'role',
            currentValue: this.baseData.roleName,
            checkRowKeys: [this.baseData.roleCode],
            isMultiple: true,
            disabled: this.baseData.dimension === 'role' ? false : true,
            required: this.baseData.dimension === 'role' ? true : false,
          },
          {
            type: 'inputNumber',
            label: '优先级',
            prop: 'priority',
            min: 0,
            required: true,
          },
          {
            type: 'select',
            label: '是否启用',
            prop: 'enable',
            options: [
              { label: '是', value: 1 },
              { label: '否', value: 0 },
            ],
            required: true,
          },
          {
            type: 'date',
            label: '生效日期',
            prop: 'validDate',
            required: true,
          },
          {
            type: 'date',
            label: '失效日期',
            prop: 'invalidDate',
            required: true,
          },
        ];
      },
    },
    mounted() {
      this.loadList();
      this._getCompanyApi();
      if (this.$route.query?.id) {
        this.loadData();
      }
    },
    methods: {
      // 获取公司
      async _getCompanyApi() {
        console.log('获取公司', this.userInfo);
        const { data } = await this.$axios.post(COMPANY_API.GET_COMPANY_LIST_API, {
          adminFlag: this.userInfo.adminFlag,
          tenantCode: this.userInfo.tenantCode,
        });
        if (data.code == 0) {
          this.companyList = data.data.map((item) => {
            return {
              label: item.createCompanyName,
              value: item.createCompanyCode,
            };
          });
        } else {
          console.error('获取公司失败');
        }
      },
      // 根据公司获取部门
      async _getDepartmentByCompanyCodeApi(companyCode) {
        console.log(companyCode, 'companyCode');
        const { data } = await this.$axios.post(COMPANY_API.GET_DEPARTMENT_LIST_API, {
          // belongCompanyCode: companyCode,
          selectCompanyCode: companyCode,
          tenantCode: this.userInfo.tenantCode,
        });
        if (data.code == 0) {
          this.departmentList = data.data.map((item) => {
            return {
              value: item?.createDepartmentCode,
              label: item?.createDepartmentName,
            };
          });
        } else {
          console.error('获取公司失败');
        }
      },
      loadData() {
        this.$axios
          .post('/component/approvalConfig/queryById', { id: this.$route.query.id })
          .then((res) => {
            this.baseData = res.data.data;
            this.baseData.approval = res.data.data?.approverName;
            this.baseData.role = res.data.data?.roleName;
            this.loadOperateType(this.baseData.billType);
            this._getDepartmentByCompanyCodeApi(this.baseData.companyCode);
          })
          .catch((err) => {
            this.$message({
              showClose: true,
              message: err.data.msg,
              type: 'error',
            });
          });
      },
      save() {
        this.$refs.baseData
          .handleSubmit()
          .then(() => {
            this.baseData.approverCompanyCode = this.baseData.departmentCode || '';
            this.baseData.approverDepartmentCode = this.baseData.companyCode || '';
            if (this.baseData.dimension === 'role') {
              this.baseData.approval = [];
              this.baseData.approverName = '';
              this.baseData.approverId = '';
            }
            if (this.baseData.dimension === 'approval') {
              this.baseData.role = [];
              this.baseData.roleCode = '';
              this.baseData.roleName = '';
            }
            this.$axios.post('/component/approvalConfig/save', this.baseData).then((res) => {
              this.dblclickEvent();
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'success',
              });
            });
          })
          .catch((err) => {
            this.$message({
              showClose: true,
              message: err.data.msg,
              type: 'error',
            });
          });
      },
      dblclickEvent() {
        let path = {
          fromPath: {
            path: this.$route.query?.id
              ? '/todoCenter/approvalConfigEdit'
              : '/todoCenter/approvalConfigAdd',
            name: this.$route.query?.id ? 'approvalConfigEdit' : 'approvalConfigAdd',
            meta: {
              keepAlive: true,
              title: this.$route.query?.id ? '审批配置编辑' : '审批配置新增',
            },
          },
          toPath: {
            path: '/todoCenter/approvalConfig',
            name: 'approvalConfig',
            meta: {
              keepAlive: false,
              title: '审批配置',
            },
            query: {},
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      loadList() {
        this.loading.startLoading();
        this.$axios
          .post('/component/approvalBillType/getSelectData')
          .then((res) => {
            this.billTypeList = res.data.data;
            this.loading.endLoading();
          })
          .catch((err) => {
            this.$message({
              showClose: true,
              message: err.data.msg,
              type: 'error',
            });
          });
      },
      loadOperateType(type) {
        this.$axios
          .post('/component/approvalOperateType/getSelectData', { billType: type })
          .then((res) => {
            this.operateTypeList = res.data.data;
          })
          .catch((err) => {
            this.$message({
              showClose: true,
              message: err.data.msg,
              type: 'error',
            });
          });
      },
      handleChangeBaseData(value, prop) {
        console.log(value, prop, '修改');
        if (prop === 'billType') {
          this.loadOperateType(this.baseData.billType);
        } else if (prop === 'approval') {
          this.baseData.approverId = value.approval[0].userId;
          this.baseData.approverName = value.approval[0].userName;
        } else if (prop === 'role') {
          this.baseData.roleCode = value.role[0].roleCode;
          this.baseData.roleName = value.role[0].roleName;
        } else if (prop === 'dimension') {
          this.baseData.roleCode = null;
          this.baseData.approverId = null;
          this.baseData.approval = null;
          this.baseData.role = null;
          this.baseData.approverName = null;
          this.baseData.roleName = null;
        } else if (prop === 'companyCode') {
          this._getDepartmentByCompanyCodeApi(value.companyCode);
        }
      },
    },
  };
</script>

<style scoped lang="scss">
  .gird {
    margin-top: 10px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 17px 0px rgba(72, 89, 102, 0.16);
    border-radius: 3px;
  }
  .top-title {
    font-size: 14px;
    border-bottom: 1px solid #ebeef5;
    padding: 15px 20px 15px 20px;
    span {
      display: inline-block;
      margin-right: 10px;
      width: 4px;
      height: 15px;
      background-color: #409eff !important;
      border-radius: 4px;
    }
  }
  .i-content {
    padding: 12px 20px 20px 20px;
  }
  .i-button {
    text-align: center;
    padding-bottom: 20px;
  }
</style>
